// extracted by mini-css-extract-plugin
export default {"disabled-row":"AttendanceMonthTableTR_disabled-row__5SbPU"};